<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">One-to-one topics</h3>
    <div class="dialog-header__title">
      <i class="icon-close" (click)="closeModal()"></i>
    </div>
  </div>
  <div class="dialog-content">
    <app-table
      [tableType]="'material'"
      [content]="dataTopics"
      [headers]="headersTopics"
    ></app-table>
  </div>
</div>
